// extracted by css-extract-rspack-plugin
export default {"difference_key":"wI7vXHYusugUx_ZL","arrow":"pEt_LYQLC6YLq1C5","redText":"yY1VgBmzIsnHQCVE","greenText":"h8hxnRkezw434Lyc"};